import type { Industry } from './types';

export const NAME = 'onboarding' as const;
export const ONBOARDING_NODE_ID = NAME;

export enum STACK_LEVEL {
  background = 0,
  clone = 1,
  element = 2,
  tooltip = 3,
}

// Registration Onboarding Flow Constants
export const ONBOARDING_STEPS = {
  NAME: 'name',
  INDUSTRY: 'industry', 
  ROLE: 'role',
  EMAIL: 'email',
  CREATING_ACCOUNT: 'creating-account',
} as const;

export const INDUSTRIES: Industry[] = [
  {
    id: 'corporate-business-services',
    title: 'Corporate & Business Services',
    emoji: '💼',
  },
  {
    id: 'technology-it',
    title: 'Technology & IT',
    emoji: '💻',
  },
  {
    id: 'engineering-manufacturing',
    title: 'Engineering & Manufacturing',
    emoji: '🏗️',
  },
  {
    id: 'sustainability-environment',
    title: 'Sustainability & Environment',
    emoji: '🏢',
  },
  {
    id: 'education-research',
    title: 'Education & Research',
    emoji: '🎓',
  },
  {
    id: 'healthcare-life-sciences',
    title: 'Healthcare & Life Sciences',
    emoji: '🩺',
  },
  {
    id: 'retail-ecommerce-hospitality',
    title: 'Retail, E-commerce & Hospitality',
    emoji: '🛍️',
  },
  {
    id: 'media-communication',
    title: 'Media & Communication',
    emoji: '🎭',
  },
  {
    id: 'legal-compliance',
    title: 'Legal & Compliance',
    emoji: '⚖️',
  },
  {
    id: 'trades-field-work',
    title: 'Trades & Field Work',
    emoji: '🛠️',
  },
  {
    id: 'other',
    title: 'Other',
  },
];

export const ONBOARDING_VALIDATION = {
  NAME_MIN_LENGTH: 1,
  NAME_MAX_LENGTH: 50,
  ROLE_MIN_LENGTH: 1,
  ROLE_MAX_LENGTH: 100,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;

export const ONBOARDING_PROGRESS_STEPS = {
  [ONBOARDING_STEPS.NAME]: 0.25,
  [ONBOARDING_STEPS.INDUSTRY]: 0.5,
  [ONBOARDING_STEPS.ROLE]: 0.75,
  [ONBOARDING_STEPS.EMAIL]: 1.0,
  [ONBOARDING_STEPS.CREATING_ACCOUNT]: 1.0,
} as const;
